import { render, staticRenderFns } from "./IndustriesList.vue?vue&type=template&id=13b5d256&scoped=true&"
import script from "./IndustriesList.vue?vue&type=script&lang=js&"
export * from "./IndustriesList.vue?vue&type=script&lang=js&"
import style0 from "./IndustriesList.vue?vue&type=style&index=0&id=13b5d256&prod&lang=scss&scoped=true&"
import style1 from "./IndustriesList.vue?vue&type=style&index=1&id=13b5d256&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b5d256",
  null
  
)

export default component.exports